import React from "react";
import Select from "react-select";

const interestOptions = [
  { label: "Investing", value: "investing" },
  { label: "Learning", value: "learning" },
  { label: "Mentoring", value: "mentoring" },
  { label: "Networking", value: "networking" },
];

const InterestAreaDropdown = ({ value, onChange }) => {
  return (
    <div className="input-group">
      <label className="input-label" htmlFor="interestArea">Area of Interest* <span className="optional-label">(You can choose multiple values)</span></label>
      <Select
       menuPosition="fixed"
      menuPlacement="top" // or "auto"
        options={interestOptions}
        isMulti
        value={interestOptions.filter(option => value.includes(option.value))}
        onChange={(selectedOptions) => {
          const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
          onChange(selectedValues);
        }}
        placeholder="Select areas of interest..."
        styles={{
          control: (provided) => ({
            ...provided,
            borderRadius: "6px",
            padding: "5px",
            marginTop: "5px",
            border: "1px solid #7C8594",
          }),
        }}
      />
    </div>
  );
};

export default InterestAreaDropdown;
